import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PageHeader from '../../components/PageHeader';
import PinCodeInput from '../../components/PinCodeInput/PinCodeInput';
import { appSlice } from '../../store/slices';

import './EnterPin.scss';

const EnterPin = () => {
	const [pin, setPin] = useState('');

	const pageProps = useSelector(state => state.app.pinConfirm);

	const dispatch = useDispatch();

	const header = pageProps.header || 'Enter PIN-code';
	const subheader = pageProps.subheader || 'You PIN-code is required to authenticate secure actions';
	const pinError = pageProps.status === 'error';
	const pinSuccess = pageProps.status === 'success';
	const confirmHandler = pageProps.confirmHandler || (() => {});
	const loading = pageProps.loading;
	const pinUpdateHandler = pageProps.pinUpdateHandler || (() => {});

	const updatePin = pin => {
		setPin(pin);
		pinUpdateHandler(pin);
		dispatch(appSlice.actions.setPinConfirmProps({ status: null }));
	};

	return (
		<div className='EnterPin'>
			<PageHeader header={header} subheader={subheader} />
			<PinCodeInput
				className='EnterPin__PinCodeInput'
				value={pin}
				onChange={updatePin}
				onFill={confirmHandler}
				error={pinError}
				success={pinSuccess}
				disabled={loading}
			/>
		</div>
	);
};

export default EnterPin;
